import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import textColorForBackground from '../../utils/textColorForBackground';
import Tooltips from './Tooltips';
import AvisoSemColecao from './vitrines/AvisoSemColecao';
import { COR_DE_FUNDO_PADRAO, ESPACAMENTO } from './vitrines/constantes';
import SilhuetaProduto from './vitrines/SilhuetaProduto';
import tempoRestante from '../../utils/tempoRestante';

interface Props {
  data: any;
  phoneWidth?: number;
}

const VitrineComCronometro: React.FC<Props> = ({ data }) => {
  const fundo = data?.background_color || COR_DE_FUNDO_PADRAO;
  const corDoTexto = textColorForBackground(fundo);
  const restante = tempoRestante(data?.schedule_end);
  const expirado = restante === '00:00:00';

  return (
    <Box
      w="100%"
      position="relative"
      backgroundColor={fundo}
      borderRadius="6px"
      transition="150ms ease"
      py={`${ESPACAMENTO}px`}
    >
      <Flex
        align="center"
        justify="space-between"
        px={`${ESPACAMENTO}px`}
        mb={3}
      >
        <Flex align="center" gap={2}>
          <Text fontWeight="bold" fontSize="md" color={corDoTexto}>
            {data?.name || 'Ofertas Relâmpago'}
          </Text>
          <Tooltips data={data} />
        </Flex>

        {restante ? (
          <Flex align="center" gap={1}>
            {restante.split(':').map((parte, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <React.Fragment key={i}>
                {i > 0 && (
                  <Text fontSize="xs" color={corDoTexto}>
                    :
                  </Text>
                )}
                <Box
                  bg="blackAlpha.800"
                  color="white"
                  px={2}
                  py={1}
                  borderRadius="4px"
                  fontSize="xs"
                  fontWeight="bold"
                >
                  {parte}
                </Box>
              </React.Fragment>
            ))}
          </Flex>
        ) : null}
      </Flex>

      <Flex gap={`${ESPACAMENTO}px`} px={`${ESPACAMENTO}px`} overflowX="hidden">
        <SilhuetaProduto />
        <SilhuetaProduto />
        <SilhuetaProduto />
      </Flex>

      {data?.action_text ? (
        <Flex justify="center" mt={3}>
          <Box
            borderWidth="1px"
            borderColor={corDoTexto}
            borderRadius="16px"
            px={4}
            py={1}
          >
            <Text fontSize="xs" fontWeight="bold" color={corDoTexto}>
              {data.action_text} ›
            </Text>
          </Box>
        </Flex>
      ) : null}

      {!data?.schedule_end ? (
        <Text fontSize="xs" color="orange.500" px={`${ESPACAMENTO}px`} mt={2}>
          Sem data final: o cronômetro não aparece e o bloco nunca expira.
        </Text>
      ) : null}
      {expirado ? (
        <Text fontSize="xs" color="red.500" px={`${ESPACAMENTO}px`} mt={2}>
          Oferta expirada — este bloco não é exibido no app.
        </Text>
      ) : null}
      {!data?.reference_id ? <AvisoSemColecao /> : null}
    </Box>
  );
};

export default VitrineComCronometro;
